import { createRoot } from 'react-dom/client';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import msalPublicClientApplication from 'core/constants/msal.constants';
import { RoleError } from 'core/model/interfaces/role.interface';
import store from 'core/store';
import { setSubject, setUserRole } from 'core/store/user-session';
import App from 'screens/App';
import monitoringInstance from 'shared/utils/monitoring-provider.utils';
import { setStoreAccessor } from 'shared/utils/store-accessor.utils';
import { decodeJWTToken, isValidRole } from 'shared/utils/token.utils';
import * as serviceWorker from './serviceWorker';

import './index.scss';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(timezone);

setStoreAccessor(store);

msalPublicClientApplication.initialize().then(() => {
  const accounts = msalPublicClientApplication.getAllAccounts();
  if (accounts.length > 0) {
    msalPublicClientApplication.setActiveAccount(accounts[0]);
  }

  msalPublicClientApplication.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const { account } = payload;

      msalPublicClientApplication.setActiveAccount(account);
    }
  });

  msalPublicClientApplication.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      if (event.payload !== null) {
        if ('accessToken' in event.payload) {
          const decodedToken = decodeJWTToken(event.payload.accessToken);
          if (isValidRole(decodedToken?.roles)) {
            store.dispatch(setUserRole(decodedToken?.roles));
            store.dispatch(setSubject(decodedToken?.sub));
          } else throw new RoleError('Invalid role');
          monitoringInstance.setUserId(decodedToken?.sub);
        }
      }
    }
  });

  const container = document.getElementById('root');
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(container!);
  root.render(<App />);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
